import React, { createContext, useContext, useMemo, useState } from 'react';

const NotesActionsContext = createContext(null);

export const NotesActionsProvider = ({ children }) => {
  const [actionsState, setActionsState] = useState({
    hasActiveNote: false,
    importingWord: false,
    exportingWord: false,
    isOwner: false,
    shareCount: 0,
    onIconEdit: null,
    onWordImport: null,
    onWordExport: null,
    onShare: null,
    onCreateTicket: null,
  });

  const value = useMemo(
    () => ({
      actionsState,
      setActionsState,
    }),
    [actionsState]
  );

  return (
    <NotesActionsContext.Provider value={value}>
      {children}
    </NotesActionsContext.Provider>
  );
};

export const useNotesActions = () => {
  const context = useContext(NotesActionsContext);
  if (!context) {
    throw new Error('useNotesActions must be used within NotesActionsProvider');
  }
  return context;
};
